// @flow
import type { Person } from 'app/common/react/components/closeup/utils/types';

const getPeople: (listOfPeople?: Array<Object>) => ?Array<Person> = (objs) => {
  const out = (objs || []).reduce(
    (out, obj) => (obj.name ? out.concat({ name: obj.name }) : out),
    [],
  );
  return out.length > 0 ? out : null;
};

export default getPeople;
